module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/error/error-507c55a3606dd6412940e4f9af0edd5f.jpg";